module.exports = require('./lib/browser/Parse.js');



//////////////////
// WEBPACK FOOTER
// /Users/alextaxiera/source/farmhand-server/client/dashboard/~/parse/index.js
// module id = ../../../dashboard/node_modules/parse/index.js
// module chunks = 1